import { render, staticRenderFns } from "./ArgTable.vue?vue&type=template&id=433e9c08&scoped=true&lang=pug&"
import script from "./ArgTable.vue?vue&type=script&lang=ts&"
export * from "./ArgTable.vue?vue&type=script&lang=ts&"
import style0 from "./ArgTable.vue?vue&type=style&index=0&id=433e9c08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433e9c08",
  null
  
)

export default component.exports